import { render, staticRenderFns } from "./top-form.vue?vue&type=template&id=b51a0bd2"
import script from "./top-form.vue?vue&type=script&lang=js"
export * from "./top-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports